import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { shallow } from "zustand/shallow";
import { Box, useTheme } from "@mui/material";
import { bottomPanel } from "../panelDimensions";
import { PyodideTerminal } from "../../PyodideTerminal/PyodideTerminal";
import { useEffect } from "react";
import { HorizontalDragHandler } from "./DragHandlers/HorizontalDragHandler";
import vwToPx from "../../utils/vwToPixels";
export const ConsolePanel = ({ NAPGenericStore, }) => {
    const [activePanels, dataVizPanelWidth, chatPanelWidth, consolePanelHeight, setConsolePanelHeight, isResizing, setIsResizing,] = NAPGenericStore((state) => [
        state._activePanels,
        state.dataVizPanelWidth,
        state.chatPanelWidth,
        state.consolePanelHeight,
        state.setConsolePanelHeight,
        state.isResizing,
        state.setIsResizing,
    ], shallow);
    const showingPlots = activePanels.plots;
    const showingChat = activePanels.chat;
    const space = (theme) => theme.spacing(7);
    const varWidth = (theme) => {
        const leftPadding = "0px";
        const dataVizPadding = showingPlots ? dataVizPanelWidth : "0px";
        const chatPadding = showingChat ? chatPanelWidth : "0px";
        return `calc(100vw + 1px - ${leftPadding} - ${dataVizPadding} - ${chatPadding} - ${space(theme)})`;
    };
    const dimensions = Object.assign(Object.assign({}, bottomPanel), { left: (theme) => `calc(${theme.spacing(7)})`, width: varWidth, height: consolePanelHeight });
    const theme = useTheme();
    const backgroundColor = "#202020";
    useEffect(() => {
        const mediaQuerySmallHeight = window.matchMedia("(max-height: 440px)");
        const mediaQueryMedHeight = window.matchMedia("(max-height: 550px)");
        //@ts-ignore
        if (window.electron || mediaQuerySmallHeight.matches) {
            setConsolePanelHeight("40px");
        }
        else if (mediaQueryMedHeight.matches) {
            setConsolePanelHeight("100px");
        }
    }, []);
    return (_jsxs(Box, Object.assign({ sx: { userSelect: isResizing ? "none" : "auto", zIndex: 2 } }, { children: [_jsx(HorizontalDragHandler, { onSetHeightCb: (h) => {
                    setConsolePanelHeight(`${h}px`);
                }, onSetIsResizingCb: (val) => {
                    setIsResizing(val);
                }, iconColor: theme.palette.secondary.light, backgroundColor: backgroundColor, minCompHeight: 18, width: varWidth(theme), left: `${theme.spacing(7)}`, initialHeight: vwToPx(consolePanelHeight) }), _jsx(Box, Object.assign({ id: "console-entrypoint", sx: dimensions }, { children: _jsx(PyodideTerminal, { backgroundColor: backgroundColor }) }))] })));
};
